import { createSelector } from "reselect";
const selector = (state) => state.inactive86;

export default createSelector([selector], (data) => data);